import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 9,
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  right: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    zIndex: 9,
    display: 'flex',
    flexDirection: 'column',
  },
  rightHeader: {
    padding: 10,
  },
  summaryInfo: {
    width: '100%',
    border: '1px solid',
    borderColor: theme.palette.primary.main,
    margin: '1em 0',
    padding: '1em',
    borderRadius: '1px',
    display: 'flex',
  },
  summaryInfoText: {
    fontSize: '13px',
    padding: '10px',
    color: theme.palette.text.primary,
  },
  centerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '1em 0',
  },
  content: {
    overflowY: 'auto',
    zIndex: 9,
    padding: 10,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
}))

export default useStyles
